import axios from "axios";
import headerRequest from "../config/headers";

const API_URL = process.env.REACT_APP_API_URL_SST;
const prefix = "unsafe-condition";
const url = window.location.pathname;
const commonParams = { url: url };

class UnsafeConditionService {
    async showAll(queryParameters) {
        const ruta = `${API_URL}/${prefix}`;
        const headers = await headerRequest();
        const params = { ...commonParams, ...queryParameters };
        return axios.get(ruta, {
            params: params,
            headers: headers,
        }).catch((error) => {
            return error;
        });
    }

    async saveUnsafeCondition(body) {
        const ruta = `${API_URL}/${prefix}`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.post(ruta, body, {
            headers: {
                ...headers,
                'Content-Type': 'multipart/form-data',
            },
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async saveUnsafeConditionClosure(body) {
        const ruta = `${API_URL}/${prefix}/closure`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.post(ruta, body, {
            headers: {
                ...headers,
                'Content-Type': 'multipart/form-data',
            },
            params: params,
        }).catch((error) => {
            return error;
        });
    }
}

export default new UnsafeConditionService();